import {
  NewOrder_SetActiveOrderMutation,
  NewOrder_SetActiveOrderMutationVariables,
} from '@/types';
import { SET_ACTIVE_ORDER_MUTATION } from '@/contexts/new-order-context-queries';
import { useCallback, useRef, useState } from 'react';
import { useMutation } from '@apollo/client';

export const useActiveOrder = ({
  activeChatUUID,
  storefrontActiveOrderUUID,
}: {
  activeChatUUID: string | null;
  storefrontActiveOrderUUID: string | null;
}) => {
  const [selectedOrder, setSelectedOrder] = useState<{
    chatUUID: string;
    orderUUID: string | null;
  } | null>(null);

  const [setStorefrontActiveOrder] = useMutation<
    NewOrder_SetActiveOrderMutation,
    NewOrder_SetActiveOrderMutationVariables
  >(SET_ACTIVE_ORDER_MUTATION);

  const latestSwitchRef = useRef(0);
  const switchActiveOrder = useCallback(
    async (uuid: string | null) => {
      if (!activeChatUUID) {
        return;
      }
      const switchId = ++latestSwitchRef.current;
      await setStorefrontActiveOrder({
        variables: { chatUUID: activeChatUUID, orderUUID: uuid },
      });
      if (switchId !== latestSwitchRef.current) {
        return;
      }
      setSelectedOrder({ chatUUID: activeChatUUID, orderUUID: uuid });
    },
    [activeChatUUID, setStorefrontActiveOrder],
  );

  return {
    activeOrderUUID:
      selectedOrder?.chatUUID === activeChatUUID
        ? selectedOrder.orderUUID
        : storefrontActiveOrderUUID,
    switchActiveOrder,
  };
};
